import { HistoryService } from '../../services/history-service.ts';
import { WindowEventService } from '../../services/window-event-service.ts';
import { FrontendLogger } from '../../utils/logger/frontend-logger.tsx';
import { FrontendAppContext } from './app-context.tsx';
import { GraphQLService } from '../../../../server/source/services/graphql-service.ts';

export const createLoggedOutAppContext = (): FrontendAppContext => {
  const logger = new FrontendLogger();
  return {
    logger,
    historyService: new HistoryService(),
    windowEventService: new WindowEventService(),
    graphqlService: new GraphQLService({ logger })
  };
};
